import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {UserBlockValueObject} from "../../../data/value-object/user/UserBlockValueObject";
import {UserBlockSearchOption} from "../../../data/search-option/user/UserBlockSearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {UserBlockIO} from "../../../io/UserIO";
import {UserBlockDescription} from "../../../data/description/user/UserBlockDescription";
import {UserBlockDescriptor} from "../../../data/descriptor/user/UserBlockDescriptor";
import ListOption from "../../ListOption";
import {UserBlockSearchOptionDescription} from "../../../data/description/user/UserBlockSearchOptionDescription";
import {
    applyUserBlockSearchOption,
    UserBlockSearchOptionField
} from "../../search-option-field/user/UserBlockSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<UserBlockValueObject[]>([])
    const option = useStatePair<UserBlockSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={UserBlockIO}
                items={items}
                option={option.value}
                index={index}
                description={UserBlockDescription}
                descriptor={UserBlockDescriptor}
                showPost
                onPostClick={() => document.location = '/users/blocks/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/users/blocks/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={UserBlockSearchOptionDescription}
                fields={UserBlockSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyUserBlockSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={UserBlockDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}